import guid from '@/lib/guid';
const table = 'charts';
import {db} from '@/services/db.js';
import {createGrid} from '@/models/grid';
import {createLayout} from '@/models/layout';

import {loadParameter, loadHydrator} from '@/components/charts/';
// import ApiService from '@/services/api.service';
import {encode, decode} from '@/lib/common';

import themes from '@/themes/themes';

// function encode(data) {
//   return window.btoa(JSON.stringify(data));
// }

// function decode(data) {
//   return JSON.parse(window.atob(data));
// }

function resolve(path, obj) {
    return path.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : null
    }, obj || self)
}

export default class LayoutElement {
  constructor({ id = null, name = `Layout`, description = ``, input = {}, schema = {}, content = {}, type = 'layout-element', parameters = null, typeGroup = 'chart', projectId= null, layout = null, tree = null, schemaLoaded = false} = {}) {
    this.id = id;
    if(!this.id) {
      this.id = guid.createId('layout-element');
    }
    this.schemaLoaded = schemaLoaded;
    this.type = type;
    this.name = name;
    this.description = description;
    this.instance = null;
    this.typeGroup = typeGroup;
    this.projectId = projectId;
    this.schema = schema;
    this.content = content;
    this.parameters = parameters;
    this.hydrator = function() {};
    this.theme = themes.default;

    this.status = {};
    this.status.schemaLoaded = schemaLoaded;
    this.status.initialised = false;

    this.tab = null;

    this.lastItem = null;
    this.lastDialogParams = null;



    this.initialised = false;

    this.initialisedBreakpoint = {};

      this.parameterGroups = [
        {id: 'form.builder', name: 'Form Builder'},
        {id: 'default', name: 'Data'},
        {id: 'design', name: 'Design'},
        {id: 'link', name: 'Links'},
        {id: 'filter', name: 'Filters'},
        {id: 'sqlQuery', name: 'SQL'},
        {id: 'code', name: 'Code'}
      ];
   
    

    // console.log("loaded this.schema", this.schema);


    this.reset();
    //this.setParameters(true);
    this.loadDefaults();
    this.tree = tree;

    let breakpoints = [
      {id: 'desktop', min: 960, max: 100000000, icon: 'laptop', style: 'width: 100%', title: 'Desktop'},
      {id: 'tablet', min: 960, max: 1264, icon: 'tablet', style: 'max-width: 960px; margin: auto;', title: 'Tablet'},
      {id: 'mobile', min: 0, max: 960, icon: 'smartphone', style: 'max-width: 600px; margin: auto; ', title: 'Mobile'}
    ];

    this.breakpoints = breakpoints;

    if(typeof this.schema.layouts == 'undefined' || !this.schema.layouts) {
      this.schema.layouts = {};
    }

    if(typeof this.schema.parameterGroups == 'undefined' || !this.schema.parameterGroups) {
      this.schema.parameterGroups = {};
    }

    // console.log("this.schema.parameterGroups", this.schema.parameterGroups);




    for (let i = 0; i < breakpoints.length; i++) {
      let breakpoint = breakpoints[i];
      if(typeof this.schema.layouts[breakpoint.id] == 'undefined') {
        this.schema.layouts[breakpoint.id] = null;
      }
    }


    // console.log("create LayoutElement layouts");
    this.render = false;
    if(typeof this.schema.layout == "undefined") {
      this.layout = createLayout({
        grids: [createGrid()]
      });
    } else {
      // console.log("this.schema.layout", this.schema.layout);

      try {
        // alert(window.innerWidth);
        this.setLayoutUsingWidth(window.innerWidth);
        // console.log("layout set using  " + window.innerWidth);
      } catch(err) {
        // console.log(err);
        this.layout = createLayout(this.schema.layout);
      }

    }

    // console.log("window.screen.width", window.screen.width);


    this.breakpoint = breakpoints[0];



    this.setBreakpoint(this.breakpoints);
    // this.schema.layouts[this.layout.breakpoint]
    // this.hydrate();
    // JSON.parse(localCopy);
  }
  setBreakpoint(breakpoints) {
    for (let i = 0; i < breakpoints.length; i++) {
      let breakpoint = breakpoints[i];
      if(breakpoint.id == this.layout.breakpoint) {
        this.breakpoint = breakpoint;
      }
    }

  }


  setLoadedStatus(status) {
    this.status.schemaLoaded = status;
  }
  getLoadedStatus() {
    return this.status.schemaLoaded;
  }
  setInitialisedStatus(status) {
    this.status.initialised = status;
  }
  getInitialisedStatus() {
    return this.status.initialised;
  }
  isInitialised() {
    try {
      if(typeof this.initialisedBreakpoint[this.breakpoint.id] != "undefined") {
        // console.log("isInitialised");
        return true;
      }
    } catch(err) {
      // err
    }
    return false;
  }
  setInitialised() {
    try {
      this.initialisedBreakpoint[this.breakpoint.id] = true;
    } catch(err) {
      // console
    }

  }
  setLayoutUsingWidth(width) {
    let breakpoint = this.getBreakpointUsingWidth(width);
    this.setLayoutUsingBreakpoint(breakpoint);
  }
  setLayoutUsingBreakpoint(breakpoint) {
    let layout = null;
    let parameters = null;

    if(typeof this.schema.layouts[breakpoint.id] != "undefined") {
      layout = this.schema.layouts[breakpoint.id];
    }


    this.breakpoint = breakpoint;

    // if(typeof this.layout == "undefined" || )
    if(!layout) {
      layout = JSON.parse(JSON.stringify(this.layout.getApiInput()));
      // layout.id = replace(this.layout, )
    }


    // console.log('breakpoint', breakpoint);
    layout.breakpoint = breakpoint.id;
    this.setLayout(layout);
  }
  setLayout(layout) {
    // console.log("setting layout", layout);
    try {
      if(layout.breakpoint == this.layout.breakpoint) {
        return null;
      }
    } catch(err) {
      // err
    }




    // if(layout.id.)
    // first backup previous layout
    try {
      this.schema.layouts[this.layout.breakpoint] = JSON.parse(JSON.stringify(this.layout.getApiInput()));
      this.schema.parameterGroups[this.layout.breakpoint] = JSON.parse(JSON.stringify(this.schema.parameters));
      // this.schema.parameterGroups
      // this.schema.parameters[this.layout.breakpoint] = JSON.parse(JSON.stringify(this.schema.parameters));
    } catch(err) {
      // console.log("err", err);
    }

    delete layout.id;
    if(typeof this.schema.parameterGroups[layout.breakpoint] != "undefined") {
      this.schema.parameters = this.schema.parameterGroups[layout.breakpoint];
    }

    this.layout = createLayout(layout);
    this.setBreakpoint(this.breakpoints);



    if(this.tree) {
      this.initialiseGrids(this.tree);
    }


  }
  getBreakpointUsingId(id) {
    // let closest = null;
    for (let i = 0; i < this.breakpoints.length; i++) {
      let breakpoint = this.breakpoints[i];
      if(breakpoint.id == id) {
        return breakpoint;
      }
    }
  }
  getBreakpointUsingWidth(width) {
    // let closest = null;
    for (let i = 0; i < this.breakpoints.length; i++) {
      let breakpoint = this.breakpoints[i];
      if(breakpoint.min <= width && breakpoint.max > width) {

        return breakpoint;
      }
    }
  }
  addGrid(parameters) {
    // @todo move this to Layout
    let maxY = Math.max(...this.layout.grids.map(o => o.y+o.h), 0);
    let maxX = Math.max(...this.layout.grids.filter(grid => grid.y+grid.h === maxY).map(o => o.x+o.w), 0);

    if(maxX >= 12) {
      maxX = 0;
    }

    if(typeof parameters == "undefined") {
      parameters = {};
    }
    parameters.x = maxX;
    parameters.y = maxY;

    let grid = createGrid(parameters);
    grid.layout = this.layout;
    // grid.setLayout(this.layout);
    this.layout.grids.push(grid);
    return grid;
  }
  ready(b) {
    this.render = b;
  }
  setTree(tree) {
      this.tree = tree;
      // console.log(tree);
      // console.log(this.parameters);
      if(this.parameters) {
        this.tree.parameters = this.parameters;
      }

  }
  getTree() {
    return this.tree;
  }
  reset() {
    return false;
  }
  setParameters(useSaved = false) {
    this.parameters = loadParameter(this.type);
  }
  loadParameterContents() {
    if (typeof this.schema.parameters == "undefined") {
      this.schema.parameters = {};
    }

    let parameters = this.parameters;
    Object.entries(this.schema.parameters).forEach(entry => {
      let key = entry[0];
      let item = entry[1];

      if (typeof parameters[key] != "undefined") {
        if(parameters[key].type == "multi-select") {
          if(!Array.isArray(item.value)) {

            parameters[key].value = [item.value];

          } else {
            parameters[key].value = item.value;
          }
        } else {
          parameters[key].value = item.value;
        }


        // Array.isArray(fruits);

      }
    });


  }
  setSchemaParameters() {

    if(!this.parameters) {
      return;
    }

    this.schema.parameters = {};
    let schemaParameters = this.schema.parameters;
    Object.entries(this.parameters).forEach(entry => {
      let key = entry[0];
      let item = entry[1];
      schemaParameters[key] = {};
      schemaParameters[key].value = typeof item.value != "undefined" ? item.value : '';

    });

    this.schema.parameterGroups[this.layout.breakpoint] = JSON.parse(JSON.stringify(this.schema.parameters));
  }
  changeTheme(tree, id) {
    if(typeof tree.themes[id] != "undefined") {
      tree.theme = tree.themes[id];
      this.theme = tree.themes[id];
    }
  }
  changed(parameter) {
    // return;
    // console.log("called");

    // const sources = this.tree;
    if (typeof parameter.items == "undefined") {
      parameter.items = [];
    }

    if(parameter.source == "parameters.layoutTheme.items") {
      this.changeTheme(this.tree, parameter.value);
    }
    // let item = parameter.items.length == 1 ? parameter.items[0] : parameter.items.find(item => item.id === parameter.value);
    try {
      if(parameter.type != "multi-select") {
      let item = parameter.items.find(item => item.id === parameter.value);
      // console.log("item found", item);
      if(!item && parameter.items.length) {
        item = parameter.items[0];
        if(typeof item.id != "undefined") {
          parameter.value = item.id;
        }
      }
    }
    } catch(err) {
      // 
    }
    // console.log("parameter", parameter);
    // if (item) {
    //   parameter.item = item;
    //   this.loadParameterItems(sources);
    // }
    this.setSchemaParameters();
    // // update parameter contents to save
    // this.loadSchemaParameters();
  }
  loadDefaults() {
    return false;

  }
  getLayers() {
    const grids = this.layout.grids;
    let layers = [];
    for(let i = 0; i < grids.length; i++) {
      for(let j = 0; j < grids[i].layers.length; j++) {
        layers.push(grids[i].layers[j]);
      }
    }
    return layers;
  }
  loadSchemaParameters() {
    this.schema = this.getApiInput().schema;
    // console.log("this.schema", this.schema);
  }


  hydrate() {
    // console.log("hydrate");
    // console.log(this.parameters);
    // this.hydrator(this.parameters, this.chartData, this);
    // this.loadSchemaParameters();
  }
  loadDefaultDataSources() {
    return false;
  }
  loadParameterItems() {
    let sources = {};
    sources.charts = this.tree.charts;
    sources.parameters = this.parameters;

    for (var key in this.parameters) {

      if (this.parameters.hasOwnProperty(key)) {

        let parameter = this.parameters[key];

        if (typeof parameter.source != 'undefined') {
          let items = resolve(parameter.source, sources);
          // console.log("parameter.source", parameter.source);
          // console.log("sources", this.tree);
          // console.log("items", items);
          parameter.items = items != null ? items : [];
          if(parameter.items.length) {
            // parameter.item = pickItem(parameter);
            //  console.log("parameter.item", parameter.item);
          }
          // console.log("item here", parameter.item);
          parameter.wait = false;
          // parameter.wait = parameter.items.length ? false : true;
        }
      }
    }
  }
  loadParameters() {
    //console.log("calling layout loadParameters");
    this.parameters = loadParameter(this.type);
    this.loadParameterContents(); // load saved contents
    this.loadParameterItems(); // load related datasources
    // console.log(this.parameters);
    // console.log(this.tree);
    //console.log(this.tree.dataSource);
    for (var key in this.parameters) {
      // console.log("key", key);
       if (this.parameters.hasOwnProperty(key)) {
         let parameter = this.parameters[key];
        // console.log("changed parameter " + key + " " + this.type, parameter);
         this.changed(parameter);
       }
    }
  }
  loadHydrator() {
    this.hydrator = loadHydrator(this.type);
  }
  loadParametersAndHydrator() {
    this.loadParameters();
    this.loadHydrator();
  }
  loadDataSources() {
    return false;

    // this.hydrate();
  }
  getApiInput(resetId) {
    this.setSchemaParameters();
    let schema = {};
    schema.layout = this.layout.getApiInput(resetId);
    schema.parameters = this.schema.parameters;
    schema.parameterGroups = this.schema.parameterGroups;

    this.schema.layouts[this.layout.breakpoint] = JSON.parse(JSON.stringify(this.layout.getApiInput(resetId)));
    schema.layouts = this.schema.layouts;

  //  console.log("schema.parameterGroups", schema.parameterGroups);


    let result = {
      projectId: this.projectId,
      name: this.name,
      type: this.type,
      typeGroup: this.typeGroup,
      description: this.description,
      schema: encode(schema),
      content: encode({}),
      grids: []
    }
    if(typeof this.id != "undefined") {
      result.id = this.id;
    }

    if(typeof resetId != "undefined" && resetId == true) {
      // console.log("recreating layout element");
      result.id = guid.createId('layout-element');
    }

    return result;
  }
  setRealTimeUpdates() {
    let grids = this.layout.grids;
    for(let i = 0; i < grids.length; i++) {
      let grid = grids[i];
      // grid.setLayout(this.layout);
      for(let ii = 0; ii < grid.layers.length; ii++) {
        let layer = grid.layers[ii];
        // console.log(layer);
        // layer.chart.parameters
      }
    }
  }
  reInitialiseGrids() {
    this.initialiseGrids(this.tree, this.lastItem, this.lastDialogParams);
  }
  initialiseGrids(tree, item = null, dialogParams = null) {
    // console.log("initialiseGrids items 2", item);
    this.tree = tree;
    this.lastItem = item;
    this.lastDialogParams = dialogParams;
    // this.setParameters();
    //if(!this.isInitialised()) {
      this.loadParametersAndHydrator();
      this.setInitialised();
    //}

    if(typeof this.layout.grids == "undefined") {
      return;
    }
    let grids = this.layout.grids;
    for(let i = 0; i < grids.length; i++) {
      let grid = grids[i];
      // grid.setLayout(this.layout);
      for(let ii = 0; ii < grid.layers.length; ii++) {
        let layer = grid.layers[ii];
        layer.setParentId(this.layout.id);
        layer.setParameters();
        layer.setTree(tree);
        try {
            layer.setReference("dialogParams", dialogParams);
            layer.setReference("dialogItem", item);
          // const parentChart = this.la
        } catch(error) {
          // continue
        }
        layer.loadParametersAndHydrator();
        // console.log("calle")
        layer.hydrate("chart-layout-element");
      }
    }

    this.setInitialisedStatus(this.getLoadedStatus());
    
  }
}
